export const restaurantProviders = {
  Iiko: 'iiko',
  RKeeper: 'rkeeper',
};
